import { Component, Input } from '@angular/core';
import { CartaoCreditoAuxiliarModel } from '@shared/model/cartao-credito-auxiliar.model';
import { EnderecoAssinaturaDto } from '@shared/service-proxies/service-proxies';
import { BuscaCepService } from '@shared/services/busca-cep.service';

@Component({
  selector: 'metodos-pagamentos',
  templateUrl: './metodos-pagamentos.component.html',
  styleUrls: ['./metodos-pagamentos.component.scss']
})
export class MetodosPagamentosComponent {
  @Input() valor: number = 0;
  public pagamentoSelecionado: string;
  public cartaoCredito: CartaoCreditoAuxiliarModel = new CartaoCreditoAuxiliarModel();
  public endereco: EnderecoAssinaturaDto = new EnderecoAssinaturaDto();
  desabilitarCamposEndereco: boolean = true;
  constructor(
    private readonly _buscaCepService: BuscaCepService,
  ) {}

  protected selectPagamento(value: string): void {
    this.pagamentoSelecionado = value;
  }

  protected hasBoleto(): boolean {
    if (this.valor > 4) return true;
    return false;
  }

  onSelectCep($event) {
    this.desabilitarCamposEndereco = true;
    this.endereco.zipCode = $event;
    if ($event.length == 8) {
      this._buscaCepService.getCep($event).subscribe(x => {
        if (x['erro']) {
          abp.message.error("CEP inválido");
        } else {
          this.endereco.streetName = x['logradouro'];
          this.endereco.city = x['localidade'];
          this.endereco.neighborhood = x['bairro'];
          this.endereco.federalUnit = x['uf'].toUpperCase();
          this.desabilitarCamposEndereco = false;
        }
      });
    }
    else {
      this.endereco.streetName = '';
      this.endereco.city = '';
      this.endereco.neighborhood = '';
      this.endereco.federalUnit = '';
      this.desabilitarCamposEndereco = true;
    }
  }
}
